import { Link } from "react-router-dom";
import { PageMeta } from "@/components/common/PageMeta";
import { ScrollSection } from "@/components/main-page/ScrollSection";
import { DocumentCard } from "@/components/ir/DocumentCard";
import { DOCUMENTS } from "@/lib/documents";

export function DataroomIndexPage() {
  return (
    <>
      <PageMeta
        title="Dataroom | COSX"
        description="COSX investor dataroom. Sign an NDA to access confidential pitch deck, financials, and legal documents."
        path="/ir/dataroom"
        noindex
      />

      <div className="relative z-10 pt-[var(--topnav-height)] px-8">
        <div className="max-w-6xl mx-auto w-full pt-16">
          <Link
            to="/ir"
            className="inline-flex items-center gap-2 text-xs font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] hover:text-[var(--color-fg)] transition-colors mb-10"
          >
            ← Back to investors
          </Link>
        </div>
      </div>

      <ScrollSection id="dataroom" title="Confidential Documents" subtitle="Access to the full dataroom requires a signed NDA. Preview the available documents below." compact>
        <div className="flex flex-col gap-4 mb-12">
          {DOCUMENTS.map((doc) => (
            <DocumentCard key={doc.id} doc={doc} blurred />
          ))}
        </div>

        <div className="flex flex-col items-center gap-5 p-8 md:p-10 border border-[var(--color-border)]">
          <p className="text-sm text-[var(--color-fg-secondary)] text-center">
            Sign a non-disclosure agreement to unlock full access to all documents.
          </p>
          <Link
            to="/ir/dataroom/nda"
            className="inline-flex items-center px-6 py-3 rounded-full text-sm font-medium bg-[var(--color-fg)] text-[var(--color-bg)] hover:opacity-90 transition-opacity"
          >
            Sign NDA →
          </Link>
        </div>
      </ScrollSection>
    </>
  );
}
